export default {
  DATA_VALIDATION: 'Data Validation',
  COMPILE_REPORT: 'Compile Report',
  COMPILING_IN_PROGRESS: 'Compiling in Progress...',
  DOWNLOAD_REPORT: 'Download Report',
  DATA_VALIDATION_CAPTION: '* The data refreshes every 24hrs',
  EMPLOYEES_WITH_INVALID_DATA: 'Employees with Invalid Data out of %COUNT% in total',
  TOTAL_NUMBER_OF_ERRORS: 'Total number of errors',
};
